/**
 * RoomJoinScreen — entra in una stanza via codice/link invito. Sbircia l'invito
 * per sapere se serve il passcode; deriva l'identità usa-e-getta e fa il redeem.
 */
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Frame, Header, Footer, Btn, Box, FieldLabel, Input } from '../components/Frame';
import { useStore } from '../lib/store';
import { peekRoomInvite, joinRoom } from '../lib/rooms';

function extractToken(s) {
  const m = String(s || '').trim().match(/[A-Za-z0-9_-]{40,50}/);
  return m ? m[0] : '';
}

export default function RoomJoinScreen() {
  const navigate = useNavigate();
  const { token: tokenParam } = useParams();
  const { mnemonic } = useStore();
  const [raw, setRaw] = useState(tokenParam || '');
  const [needPass, setNeedPass] = useState(false);
  const [passcode, setPasscode] = useState('');
  const [nickname, setNickname] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const token = extractToken(raw);

  useEffect(() => {
    if (!token) { setNeedPass(false); return; }
    let alive = true;
    peekRoomInvite(token).then((p) => { if (alive) setNeedPass(!!p.requirePasscode); }).catch(() => {});
    return () => { alive = false; };
  }, [token]);

  async function onJoin() {
    setErr(null); setBusy(true);
    try {
      const { roomId } = await joinRoom({
        mnemonic, token,
        passcode: passcode.trim().toUpperCase() || undefined,
        nickname: nickname.trim() || undefined,
      });
      navigate(`/room/${roomId}`, { replace: true });
    } catch (e) { setErr(e.message); setBusy(false); }
  }

  return (
    <Frame statusLeft="ENTRA" statusRight="">
      <Header title="// Entra in una stanza" crumb="◀ indietro" onCrumbClick={() => navigate(-1)} />
      <div className="space-y-4">
        <div>
          <FieldLabel>Codice o link invito</FieldLabel>
          <Input value={raw} onChange={(e) => setRaw(e.target.value)} placeholder="incolla qui" />
        </div>
        {needPass && (
          <div>
            <FieldLabel>Passcode (dato a voce)</FieldLabel>
            <Input value={passcode} onChange={(e) => setPasscode(e.target.value)} maxLength={8} placeholder="8 caratteri" />
          </div>
        )}
        <div>
          <FieldLabel>Soprannome nella stanza (opz.)</FieldLabel>
          <Input value={nickname} onChange={(e) => setNickname(e.target.value)} maxLength={24} />
        </div>
        <Box variant="warn" className="text-[13px]">
          🎭 Entrerai con un'identità <b>usa-e-getta</b>: gli altri non vedono il tuo sigil.
        </Box>
        {err && <Box variant="danger" className="text-[14px] text-red-400">{err}</Box>}
      </div>
      <Footer>
        <Btn variant="primary" onClick={onJoin} disabled={busy || !token}>{busy ? 'ingresso…' : 'Entra'}</Btn>
      </Footer>
    </Frame>
  );
}
